import cx from "classnames";
import { AnswerWithReviewer } from "types/answer-with-reviewer.type";
import { OptionQuestion } from "types/question";
import MultipleChoiceFeedback from "./MultipleChoiceFeedback";
import MultipleChoicePieChart from "./MultipleChoicePieChart";
import QuestionHeader from "./QuestionHeader";

type MultipleChoiceFeedbacksProps = {
  question: OptionQuestion;
  answersWithReviewers: AnswerWithReviewer[];
  showUserProfileCard?: boolean;
  isSingleCol?: boolean;
  hint?: string;
  usePieChart?: boolean;
};

const MultipleChoiceFeedbacks: React.FC<MultipleChoiceFeedbacksProps> = ({
  question,
  answersWithReviewers,
  showUserProfileCard = false,
  isSingleCol = true,
  hint,
  usePieChart = false,
}) => {
  const { sequence, label } = question;

  return (
    <div className="flex flex-col text-neutral-150">
      <QuestionHeader sequence={sequence} label={label} hint={hint} />
      {usePieChart ? (
        <MultipleChoicePieChart
          question={question}
          answersWithReviewers={answersWithReviewers}
        />
      ) : (
        <div
          className={cx("grid gap-6", {
            "grid-cols-2": !isSingleCol,
            "grid-cols-1": isSingleCol,
          })}
        >
          {answersWithReviewers?.map(({ answer, reviewer }) => {
            return (
              <MultipleChoiceFeedback
                key={answer.id}
                answer={answer}
                reviewer={reviewer}
                showUserProfileCard={showUserProfileCard}
                question={question}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultipleChoiceFeedbacks;
